// import consts from "@/consts"
import {arrayFilter_OnlyUnique, getApiProps, updateObjectByDiff} from "@/lib/lib";
// import {arraySplitIntoChunks} from "@/lib/lib";

export default {
    state: {
        greenseeTrips_index: [],
        greenseeTrips: [],
        greenseeTrips_last_hour: [],
    },
    actions: {
        fetchGreenseeTrips4Date({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                args = {unitId: '', date: '', ...args}
                if (args.date == 'today' || !args.date) args.date = getters.getDateToday
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !args.date) {
                    return reject(false)
                }

                if (args.unitId > 0 && !args.force) {
                    let index = getters.getGreenseTripsIndex.find(i => (i.unitId == args.unitId && i.date == args.date))
                    if (index) {
                        return resolve(true)
                    }
                }

                dispatch('setLastCall', {name: 'fetchGreenseeTrips4Date', args, time: Date.now() / 1000})
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastGreenseeTrips', args, time: Date.now() / 1000})
                    dispatch('setLastCall', {name: 'fetchGreenseeTripsChanged', args, time: Date.now() / 1000})
                }

                let params = getApiProps('greenseeTrips', {withAddress: 1, ...args})
                delete params.unitId;delete params.date;
                this.$api.greenseeTrips.get4Date(args.unitId, args.date, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeGreenseeTrips', response.data)
                            commit('setGreenseeTripsIndex', {...args, count: response.data.length})
                            if (args.unitId && isToday) {
                                dispatch('fetchGreenseeTripsLastTime', args)
                            }
                            if (!args.unitId && response.data.length) {
                                response.data
                                    .map(t => t.unit_id)
                                    .filter(arrayFilter_OnlyUnique)
                                    .forEach(unitId => {
                                        commit('setGreenseeTripsIndex', {...args, unitId, count: 1})
                                    })
                            }
                            resolve(true)
                        } else {
                            reject(response)
                            console.error(response);
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchGreenseeTrips4Date', args, inprogress: false})
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastGreenseeTrips', args, inprogress: false})
                            dispatch('setLastCall', {name: 'fetchGreenseeTripsChanged', args, inprogress: false})
                        }
                    });
            })
        },
        fetchGreenseeTrips4Period({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !args.from || !args.to) {
                    return reject(false)
                }

                if (args.unitId > 0 && !args.force) {
                    let greenseeTrip = getters.getGreenseTrips.find(t => (t.id && t.unit_id == args.unitId && t.time_start?.utc == args.from && t.time_end?.utc == args.to))
                    if (greenseeTrip) {
                        return resolve(true)
                    }
                }

                dispatch('setLastCall', {name: 'fetchGreenseeTrips4Period', args, time: Date.now() / 1000})
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastGreenseeTrips', args, time: Date.now() / 1000})
                    dispatch('setLastCall', {name: 'fetchGreenseeTripsChanged', args, time: Date.now() / 1000})
                }

                let params = getApiProps('greenseeTrips', {withAddress: 1, ...args})
                delete params.unitId;delete params.from;delete params.to;
                this.$api.greenseeTrips.get4Period(args.unitId, args.from, args.to, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeGreenseeTrips', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchGreenseeTrips4Period', args, inprogress: false})
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastGreenseeTrips', args, inprogress: false})
                            dispatch('setLastCall', {name: 'fetchGreenseeTripsChanged', args, inprogress: false})
                        }
                    });
            })
        },

        reloadGreenseeTrips({commit, dispatch}, args) {
            commit('clearGreenseeTrips')
            return dispatch('fetchGreenseeTrips4Date', {date: 'today', ...args})
        },

        //sayHello() {}
    },
    mutations: {
        setGreenseeTripsIndex(state, params) {
            let i = state.greenseeTrips_index.findIndex(i => i.date == params.date && i.unitId == params.unitId)
            if (i < 0) {
                state.greenseeTrips_index.push(Object.freeze({...params}))
            } else {
                state.greenseeTrips_index[i] = Object.freeze({...state.greenseeTrips_index[i], ...params})
            }
        },
        storeGreenseeTrips(state, nTrips) {
            const exactKeys = new Set(state.greenseeTrips.map(st => `${st.unit_id}|${st.time_start?.utc}|${st.time_end?.utc}`))
            nTrips = nTrips
                .filter(t => !exactKeys.has(`${t.unit_id}|${t.time_start?.utc}|${t.time_end?.utc}`))
            //.map(t => Object.freeze(t))

            // if(nTrips.length) state.greenseeTrips.push(...nTrips)
            if (!nTrips.length) return false
            if (!state.greenseeTrips.length) {
                state.greenseeTrips = nTrips
                return true
            }
            const indexByIdentity = new Map(state.greenseeTrips.map((st, i) => [`${st.unit_id}|${st.time_start?.utc}`, i]))
            nTrips.forEach(function (nTrip) {
                const identityKey = `${nTrip.unit_id}|${nTrip.time_start?.utc}`
                let i = indexByIdentity.has(identityKey) ? indexByIdentity.get(identityKey) : -1
                if (i < 0) {
                    indexByIdentity.set(identityKey, state.greenseeTrips.length)
                    state.greenseeTrips.push(nTrip) //(Object.freeze(nTrip))
                } else
                {
                    updateObjectByDiff(state.greenseeTrips[i], nTrip)
                    // nTrip = {...state.greenseeTrips[i], ...nTrip}
                    // state.greenseeTrips[i] = nTrip //Object.freeze(nTrip)
                }
            })
        },
        storeGreenseeTripsLastHour(state, args) {
            state.greenseeTrips_last_hour = state.greenseeTrips_last_hour.filter(st => {
                return st.unit_id != args.unitId || st.time_start?.utc >= args.time_start
            })

            let nTrips = args.data
            nTrips = nTrips
                .filter(st => {
                    return st.time_end?.utc > args.time_start
                })
                .filter(t => !state.greenseeTrips_last_hour.find(st => {
                    return st.unit_id == t.unit_id
                        && st.time_start?.utc == t.time_start?.utc
                        && st.time_end?.utc == t.time_end?.utc
                }))
            //.map(t => Object.freeze(t))

            // if(nTrips.length) state.greenseeTrips_last_hour.push(...nTrips)
            if (!nTrips.length) return false
            if (!state.greenseeTrips_last_hour.length) {
                state.greenseeTrips_last_hour = nTrips
                return true
            }
            nTrips.forEach(function (nTrip) {
                let i = state.greenseeTrips_last_hour.findIndex(st => {
                    return st.unit_id == nTrip.unit_id
                        && st.time_start?.utc == nTrip.time_start?.utc
                    // && st.time_end?.utc == nTrip.time_end?.utc
                })
                if (i < 0) {
                    state.greenseeTrips_last_hour.push(nTrip) //(Object.freeze(nTrip))
                } else
                {
                    updateObjectByDiff(state.greenseeTrips_last_hour[i], nTrip)
                    // nTrip = {...state.greenseeTrips_last_hour[i], ...nTrip}
                    // state.greenseeTrips_last_hour[i] = nTrip //Object.freeze(nTrip)
                }
            })
        },
        clearGreenseeTrips(state, {unitId} = {}) {
            if (unitId) {
                state.greenseeTrips_last_hour = state.greenseeTrips_last_hour.filter(t => (t.unit_id || t.object_id) != unitId)
                state.greenseeTrips = state.greenseeTrips.filter(t => (t.unit_id || t.object_id) != unitId)
                state.greenseeTrips_index = state.greenseeTrips_index.filter(i => i.unitId != unitId)
            } else {
                state.greenseeTrips_last_hour = [];
                state.greenseeTrips = [];
                state.greenseeTrips_index = [];
            }
        },
    },
    getters: {
        getGreenseTripsIndex(state) {
            return state.greenseeTrips_index
        },
        getGreenseTrips(state) {
            return [...state.greenseeTrips, ...state.greenseeTrips_last_hour]
        },
        getGreenseTripsById(state) {
            return state.greenseeTrips.reduce((out, trip) => {
                out[trip.id] = trip
                return out;
            }, {})
        },
        getGreenseTripsMaxTimeEndByUnitsIds(state) {
            return state.greenseeTrips.reduce((MaxTimeEndByUnitsIds, greenseeTrip) => {
                if (+(greenseeTrip?.time_end?.utc || 0) > +(MaxTimeEndByUnitsIds[greenseeTrip.unit_id] || 0)) {
                    MaxTimeEndByUnitsIds[greenseeTrip.unit_id] = greenseeTrip?.time_end?.utc
                }
                return MaxTimeEndByUnitsIds
            }, {})
        },
    }
}
